module.exports = __webpack_public_path__ + "static/img/open_btn.70245be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/hk/open_btn.png
// module id = 8IMP
// module chunks = 1 3